import React from "react";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { List, Typography, ListProps, TableRow, Table } from "@mui/material";
import { TableBodyCell } from "@rentablo/components";
import { NewsItemProps, NewsItem } from "./NewsListItem";

interface CustomProps {
  items?: NewsItemProps[];
}

export type NewsListProps = ListProps & CustomProps;

const NoNewsTypographyStyled = styled(Typography)`
  margin-top: ${({ theme }) => theme.spacing(1)};
  display: flex;
  justify-content: center;
`;

export const NoNewsText = () => {
  const { t } = useTranslation();
  return (
    <Table>
      <TableRow>
        <TableBodyCell>
          <NoNewsTypographyStyled variant="body1">
            {t("investment.newsBlock.noNews")}
          </NoNewsTypographyStyled>
        </TableBodyCell>
      </TableRow>
    </Table>
  );
};

export const NewsList = ({ items = [], ...props }: NewsListProps) => {
  if (!items.length) return <NoNewsText />;

  return (
    <List {...props}>
      {items.map((item) => (
        <NewsItem key={`${item.title}${item.link}`} {...item} />
      ))}
    </List>
  );
};
